module.exports = __webpack_public_path__ + "static/img/power-img05-01.b456f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resolution/power-img05-01.png
// module id = +2wo
// module chunks = 7